import React from "react";

import HeroSection from "./SmsOtpService/HeroSection";
import SolutionsSection from "./SmsOtpService/SolutionsSection";
import SecuritySection from "./SmsOtpService/SecuritySection";
import WorkflowSection from "./SmsOtpService/WorkflowSection";
import FAQCTASection from "./SmsOtpService/FAQCTASection";
import FeatureSection from "./SmsOtpService/CommunicationSection";

const SmsOtpService = () => {
  return (
    <main className="relative min-h-screen overflow-hidden bg-[#050505] text-white">
      {/* ============================================================
          HERO SECTION
      ============================================================ */}
      <HeroSection />

      {/* ============================================================
          SOLUTIONS SECTION
      ============================================================ */}
      <SolutionsSection />

      {/* ============================================================
          COMMUNICATION SECTION
      ============================================================ */}
      <FeatureSection />

      {/* ============================================================
          SECURITY SECTION
      ============================================================ */}
      <SecuritySection />

      {/* ============================================================
          WORKFLOW SECTION
      ============================================================ */}
      <WorkflowSection />

      {/* ============================================================
          FAQ + CTA SECTION
      ============================================================ */}
      <FAQCTASection />
    </main>
  );
};

export default SmsOtpService;